export default "__VITE_ASSET__79d39835__"